import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function IconButton({title, icon, onClick, boxClassName}) {
  return (
    <button onClick={onClick} className={` ${boxClassName} p-2 mb-4 flex items-center shadow justify-center rounded-lg border border-gray-300 hover:text-white hover:bg-gray-600`}>
        <FontAwesomeIcon icon={icon} className={`${title? 'mr-3': ''}`} size={'1x'}/>
        {title && <span className='flex'>{title}</span>}
    </button>
  )
}
